import { __assign, __extends, __rest } from "tslib";
import React, { PureComponent } from 'react';
import { ButtonNext } from 'wix-ui-core/dist/es/src/components/button-next';
import PropTypes from 'prop-types';
import { iconChildSize } from './constants';
import { generateDataAttr } from '../utils/generateDataAttr';
import { st, classes } from './IconButton.st.css';
var IconButton = /** @class */ (function (_super) {
    __extends(IconButton, _super);
    function IconButton(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Sets focus on the button element
         */
        _this.focus = function () {
            _this.button.current && _this.button.current.focus();
        };
        _this.button = React.createRef();
        return _this;
    }
    IconButton.prototype.render = function () {
        var _a = this.props, skin = _a.skin, className = _a.className, priority = _a.priority, size = _a.size, children = _a.children, dataHook = _a.dataHook, ariaLabel = _a.ariaLabel, ariaLabelledBy = _a.ariaLabelledBy, rest = __rest(_a, ["skin", "className", "priority", "size", "children", "dataHook", "ariaLabel", "ariaLabelledBy"]);
        var childSize = iconChildSize[size];
        return (React.createElement(ButtonNext, __assign({}, rest, { ref: this.button, className: st(classes.root, { skin: skin, priority: priority, size: size }, className) }, generateDataAttr(this.props, ['skin', 'priority', 'size']), { "data-hook": dataHook, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy }), children &&
            React.cloneElement(children, {
                size: childSize,
                width: childSize,
                height: childSize,
                'aria-hidden': true,
            })));
    };
    IconButton.displayName = 'IconButton';
    IconButton.propTypes = {
        /** render as some other component or DOM tag */
        as: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object,
            PropTypes.string,
        ]),
        /** Classes to be applied to the root element */
        className: PropTypes.string,
        /** Used for passing any wix-style-react icon. For external icon make sure to follow ux sizing guidelines */
        children: PropTypes.node,
        /** Button skins */
        skin: PropTypes.oneOf([
            'standard',
            'inverted',
            'light',
            'transparent',
            'premium',
        ]),
        /** Button priority */
        priority: PropTypes.oneOf(['primary', 'secondary']),
        /** Button size */
        size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large']),
        /** Click event handler  */
        onClick: PropTypes.func,
        /** Applies disabled styles */
        disabled: PropTypes.bool,
        /** String based data hook */
        dataHook: PropTypes.string,
        /** Defines a string value that labels the button element */
        ariaLabel: PropTypes.string,
        /** Identifies the element that labels the button element */
        ariaLabelledBy: PropTypes.string,
    };
    IconButton.defaultProps = {
        skin: 'standard',
        priority: 'primary',
        size: 'medium',
        disabled: false,
    };
    return IconButton;
}(PureComponent));
export default IconButton;
//# sourceMappingURL=IconButton.js.map